<template>
  <v-app-bar
    app
    color="teal darken-2"
    dark
    class="elevation-10"
  >
  <v-app-bar-nav-icon aria-label="menu" @click.stop="toggleDrawer"></v-app-bar-nav-icon>

    <div class="d-flex align-center">
      <v-img
        alt="Vuetify Logo"
        class="shrink mr-0"
        contain
        src="img/gofrance_solo_o.png"
        transition="scale-transition"
        width="50"
      />
    <span class="font-weight-black text-capitalize baloo-text" style="font-size: x-large">
Go-France</span>

    </div>

    <v-spacer></v-spacer>
<v-btn v-if="$store.getters.filterIcon" @click="$store.dispatch('openFilterPointsDrawer')" icon><v-icon>mdi-filter</v-icon></v-btn>

  </v-app-bar>
</template>
<script>
export default {
  props: ['drawer', 'toggleDrawer'],
  data: () => ({

  }),
  computed: {
    d:{
      set: function() {
        this.setDrawer(!this.drawer);
      },
      get: function() {
        return this.drawer;
      }
    }
  }

}
</script>
